import styles from './Loading.module.css';

const Loading = () => (
    <div className={styles.container}>
        <div className={styles.spinner} role="status" aria-label="Loading" />
    </div>
);

export default Loading;
